export default class QRCodeDetailsResponse {
    constructor(supportedLocales) {
        this.translations = [];
        this.coinsToEarn = null;
        this.activeFrom = null;
        this.activeTo = null;
        this.id = null;
        this.status = null;
        this.numericCode = '';
        this.scanCount = 1;
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                description: null,
            };
        });
        this.supportedLocales = supportedLocales;
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;
            to.status = from.status;
            to.coinsToEarn = from.coinsToEarn;
            to.numericCode = from.numericCode;
            to.activeFrom = new Date(from.activeFrom);
            to.activeTo = new Date(from.activeTo);
            to.scanCount = from.scanCount;
            //to.translations = from.translations;

            to.supportedLocales.forEach((element) => {
                to.translations[element] = {
                    title: from.translations[element]?.title,
                    description: from.translations[element]?.description,
                };
            });
        } else {
            to = new QRCodeDetailsResponse();
        }
    }

    static copy(to, from) {
        //const to = new QRCodeDetailsResponse();
        QRCodeDetailsResponse.assign(from, to);
        return to;
    }
}
